import {memo} from 'react';

import {
  hasPermission,
  NAVIGATION_POLICY_REQUEST,
  usePolicyCheck,
} from '#queries/policies/index.js';
import {useSessionStore} from '#stores/session/index.js';
import {Avatar} from '#ui/atoms/avatar/index.js';
import {Icon} from '#ui/atoms/icon/index.js';
import {ListButton} from '#ui/molecules/list_button/index.js';
import {Popover, PopoverPlacement} from '#ui/molecules/popover/index.js';

import {WhatsNew} from '../announcekit/index.js';
import * as styles from './style.css.js';

export const Toolbar = memo(function Toolbar() {
  const {user} = useSessionStore();
  const {data: policyData} = usePolicyCheck(NAVIGATION_POLICY_REQUEST);
  const displayName = user?.nickname || user?.name || 'User';
  const showAdminLinks = hasPermission(policyData, 'application', 'app_admin');
  const showOrganizationLink = hasPermission(
    policyData,
    'organization',
    'show'
  );

  return (
    <header className={styles.container}>
      <div className={styles.spacer} />
      <div className={styles.actions}>
        <a
          href="https://docs.growthloop.com/docs/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Documentation
        </a>
        <WhatsNew />
        <Popover.Root>
          <Popover.Trigger asChild>
            <div className={styles.userMenu}>
              <Avatar
                name={displayName}
                className={styles.avatarRounded}
                size={13}
              />
              <span>{displayName}</span>
              <Icon name="down" size={8} />
            </div>
          </Popover.Trigger>
          <Popover.Portal>
            <Popover.Content
              placement={PopoverPlacement.BOTTOM_END}
              sideOffset={8}
            >
              <div className={styles.userDropdown}>
                <ListButton
                  className={styles.userDropdownItem}
                  href="/user"
                  icon="person"
                >
                  Profile
                </ListButton>
                {showOrganizationLink ? (
                  <ListButton
                    className={styles.userDropdownItem}
                    href="/organization"
                    icon="corporateFare"
                  >
                    Organization
                  </ListButton>
                ) : null}
                {showAdminLinks ? (
                  <>
                    <ListButton
                      className={styles.userDropdownItem}
                      href="/admin/organizations"
                      icon="settings"
                    >
                      Admin
                    </ListButton>
                    <ListButton
                      className={styles.userDropdownItem}
                      href="/admin/debug"
                      icon="troubleshoot"
                    >
                      Debug
                    </ListButton>
                  </>
                ) : null}
                <ListButton
                  className={styles.userDropdownItem}
                  href="/auth/logout"
                  icon="logout"
                >
                  Logout
                </ListButton>
              </div>
            </Popover.Content>
          </Popover.Portal>
        </Popover.Root>
      </div>
    </header>
  );
});
